module.exports = __webpack_public_path__ + "img/4.c43a7e4b.png";